// TODO: remove this once we have a way to import the Select component
// bend-lint-disable-next-line strict-exports

import { BreezeSingleStarIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { Toggle } from 'foundations-components/transitional/components/Toggle';
import { useFilterConfig } from '../hooks/useFilterConfig';
import { SelectFilter } from './reusableFilters/SelectFilter';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function UniversalFilterControls() {
  const {
    ProductType,
    PortalInstallable
  } = useFilterConfig();
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    children: [/*#__PURE__*/_jsx(SelectFilter, {
      filter: ProductType
    }), /*#__PURE__*/_jsx(SelectFilter, {
      filter: PortalInstallable
    }), /*#__PURE__*/_jsx(IconHolder, {
      icon: BreezeSingleStarIcon,
      color: "fill-accent-magenta-pressed",
      marginInlineStart: "200"
    }), /*#__PURE__*/_jsx(Text, {
      htmlFor: "eco_breezeCertified",
      as: "label",
      children: "Works with Breeze"
    }), /*#__PURE__*/_jsx(Toggle, {
      id: "eco_breezeCertified",
      size: "extra-small",
      marginInlineStart: "200"
    })]
  });
}